import { autoRegisterFeature } from '@store/features/factory';

import { payments } from './store/feature';

// Auto-register the feature
autoRegisterFeature(payments);

// Export components
export type { RequestPaymentButtonProps } from './components';
export {
  BillPatientsPage,
  RequestPaymentButton,
  StripeConnectButton,
  StripeConnectStatus,
  StripeInvoicesTable,
  StripeInvoicesTableCard,
} from './components';

// Export modal components (for lazy loading in modal registry)
export { default as PaymentRequestModal } from './components/PaymentRequestModal';
export { default as StripeConnectInfoModal } from './components/StripeConnectInfoModal';

// Export hooks
export { useRequestPayment } from './hooks/useRequestPayment';

// Export store functionality
export {
  payments,
  paymentsApi,
  useCreateStripeConnectMutation,
  useCreateStripeDashboardLinkMutation,
  useGetStripeConnectStatusQuery,
  useGetStripeInvoicesQuery,
  useLazyGetStripeInvoicesQuery,
  useSendPaymentRequest,
  useSendPaymentRequestMutation,
  useStripeConnect,
  useStripeDashboard,
} from './store';

// Export types (renamed to avoid conflicts)
export type {
  PaymentRequest,
  PaymentRequestResponse,
  StripeConnectRequest,
  StripeConnectResponse,
  StripeConnectStatus as StripeConnectStatusType,
  StripeDashboardLinkRequest,
  StripeDashboardLinkResponse,
  StripeInvoice,
  StripeInvoicesResponse,
} from './types';
